function emit(el, name, detail, cancelable) {
    return el.dispatchEvent(
        new CustomEvent(name, { bubbles: true, composed: true, cancelable: !!cancelable, detail })
    );
}

function removeIfAllowed(root, reason) {
    const ok = emit(root, "sds-dismiss", { reason }, true);
    if (ok) root.remove();
}

export function initNotification(root) {
    const dismiss = root.getAttribute("data-dismiss") || "enabled";

    const closeBtn = root.querySelector("[data-sds-notification-close]");
    const dismissBtn = root.querySelector("[data-sds-notification-dismiss]");
    const confirmBtn = root.querySelector("[data-sds-notification-confirm]");

    if (closeBtn && dismiss !== "disabled") {
        closeBtn.addEventListener("click", () => removeIfAllowed(root, "click"));
    }

    if (dismissBtn) {
        dismissBtn.addEventListener("click", () => removeIfAllowed(root, "button"));
    }

    if (confirmBtn) {
        confirmBtn.addEventListener("click", () => {
            emit(root, "sds-confirm", { source: "button" }, false);
        });
    }

    root.addEventListener("keydown", (e) => {
        if (dismiss !== "enabled") return;
        if (e.key === "Escape") {
            e.stopPropagation();
            removeIfAllowed(root, "click");
        }
    });

}

